import { trackProductTileQuantityPickerChooseOptionsClick } from "@faire/web-api/events/productTile/click/quantityPickerChooseOptions";
import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";

import { getPromotedByString } from "@faire/retailer/hooks/ProductTileImpression/__internal__/getPromotedByString";
import { useProductTileClickImpressionContext } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressionContext";

export const useRecordChooseOptionClickEvent = (
  productTile: ILeanProductTile | undefined,
  recordImpressions = false
) => {
  const { context, requestId } = useProductTileClickImpressionContext();

  return useEffectEvent(() => {
    const { product } = productTile ?? ILeanProductTile.build({});
    if (!product?.token || !recordImpressions) {
      return;
    }

    const eventPromotedByString = getPromotedByString(product.promoted_by);
    trackProductTileQuantityPickerChooseOptionsClick(
      context,
      requestId ?? "",
      product.token,
      eventPromotedByString,
      product.impression_id ?? ""
    );
  });
};
